import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  declare checkboxTargets: HTMLInputElement[]

  submitForm() {
    const form = this.element as HTMLFormElement
    form.submit()
  }

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = true
      }
    })
  }

  selectNone() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
